import { UnsubscribeContent, UnsubscribeLayout } from '@features/EmailUnsubscribe';

/** /unsubscribe?token=… — отписка от напоминаний по ссылке из письма, без входа (вне AppGate). */
export default function UnsubscribePage() {
  return (
    <UnsubscribeLayout>
      <UnsubscribeContent />
    </UnsubscribeLayout>
  );
}
